import { render, staticRenderFns } from "./Planning2.vue?vue&type=template&id=1280b684&"
import script from "./Planning2.vue?vue&type=script&lang=js&"
export * from "./Planning2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports